"use strict";

module.exports = function (data) {

  this.count = data.length;

  return data;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/filters/set-count.js
// module id = 2195
// module chunks = 0